/* typewriter.ro — RO/EN switch, lei/€ display, filters, mobile menu, waveforms */
(function () {
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // ---------- language ----------
  // [data-en]      innerHTML swapped (Romanian kept in data-ro)
  // [data-en-ph]   placeholder, [data-en-aria] aria-label
  // [data-l="ro|en"] whole blocks shown for one language only (policies, long pages)
  var LANG = 'tw-lang', lang = 'ro';
  var pageLoc = document.documentElement.getAttribute('data-loc') === 'en' ? 'en' : 'ro';
  function basePath() { var p = location.pathname; return p === '/en' ? '/' : (p.indexOf('/en/') === 0 ? p.slice(3) : p); }
  function swapAttr(sel, attr, enAttr, roAttr, l) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (!el.hasAttribute(roAttr)) el.setAttribute(roAttr, el.getAttribute(attr) || '');
      el.setAttribute(attr, l === 'en' ? el.getAttribute(enAttr) : el.getAttribute(roAttr));
    });
  }
  function apply(l) {
    lang = l;
    document.documentElement.lang = l;
    document.documentElement.removeAttribute('data-pl');
    document.querySelectorAll('[data-en]').forEach(function (el) {
      if (!el.hasAttribute('data-ro')) el.setAttribute('data-ro', el.innerHTML);
      el.innerHTML = l === 'en' ? el.getAttribute('data-en') : el.getAttribute('data-ro');
    });
    swapAttr('[data-en-ph]', 'placeholder', 'data-en-ph', 'data-ro-ph', l);
    swapAttr('[data-en-aria]', 'aria-label', 'data-en-aria', 'data-ro-aria', l);
    document.querySelectorAll('[data-l]').forEach(function (el) { el.hidden = el.getAttribute('data-l') !== l; });
    document.querySelectorAll('[data-lang]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-lang') === l)); });
    if (document.body) document.body.classList.toggle('is-en', l === 'en');
    renderMoney();
    document.dispatchEvent(new CustomEvent('tw:lang', { detail: l }));
  }

  // ---------- lei / € ----------
  // Every price is printed as <x data-cents data-ron> (lei, VAT included). The euro price is FIXED:
  // lei ÷ the store's pricing rate (shop metafield twr.eur_rate, set below the BNR rate so conversion
  // costs are covered), rounded up to ,90. Same formula as the EUR price list used at checkout, so the
  // figure shown is the figure charged. No live exchange rate, so it never moves between visits.
  var CUR = 'tw-cur', FX = window.twFx || {}, cur = get(CUR) || 'RON';
  var fxOn = FX.base === 'RON' && Number(FX.rate) > 0;
  function eurCents(c) { var e = c / Number(FX.rate); return Math.max(90, Math.ceil((e - 90) / 100) * 100 + 90); }
  function eur(cents) {
    return new Intl.NumberFormat(lang === 'en' ? 'en-IE' : 'ro-RO', { style: 'currency', currency: 'EUR', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2 }).format(eurCents(cents) / 100);
  }
  function renderMoney() {
    var on = cur === 'EUR' && fxOn;
    document.querySelectorAll('[data-cents]').forEach(function (el) {
      var ron = el.getAttribute('data-ron'), c = Number(el.getAttribute('data-cents'));
      if (on) { el.innerHTML = eur(c) + ' <span class="ron"></span>'; el.querySelector('.ron').textContent = ron; }
      else el.textContent = ron;
    });
    document.querySelectorAll('[data-cur-box]').forEach(function (box) {
      box.hidden = !fxOn;
      box.querySelectorAll('[data-cur]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cur') === (on ? 'EUR' : 'RON'))); });
    });
    document.querySelectorAll('[data-fx-note]').forEach(function (n) {
      n.hidden = !on;
      if (!on) return;
      n.textContent = FX.live
        ? (lang === 'en' ? 'Fixed price in euro, VAT included. This is exactly the amount you pay in euro.'
                         : 'Preț fix în euro, cu TVA inclus. Este exact suma pe care o plătești în euro.')
        : (lang === 'en' ? 'Fixed price in euro, VAT included. Paying in euro opens with the shop; until then orders are paid in lei.'
                         : 'Preț fix în euro, cu TVA inclus. Plata în euro va fi disponibilă la deschiderea magazinului; până atunci, comenzile se plătesc în lei.');
    });
  }
  window.twMoney = { render: renderMoney, eurCents: eurCents };

  // ---------- filters: one open at a time, close on outside tap or Escape ----------
  function closeFilters(except) {
    document.querySelectorAll('details.flt[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  document.addEventListener('pointerdown', function (e) {
    var d = e.target.closest && e.target.closest('details.flt');
    closeFilters(d);
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('details.flt') && d.open) closeFilters(d);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('details.flt[open]');
    if (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); }
  });

  // ---------- on /en pages, internal links stay in English ----------
  if (pageLoc === 'en') document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="/"]'); if (!a) return;
    var h = a.getAttribute('href');
    if (/^\/(\/|en(\/|$|\?|#)|cdn\/|apps\/|checkouts?\b|customer_authentication)/.test(h)) return;
    a.setAttribute('href', '/en' + (h === '/' ? '' : h));
  }, true);

  // ---------- clicks: language, currency, cookie preferences, mobile menu ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lang]');
    if (b) {
      var nl = b.getAttribute('data-lang');
      set(LANG, nl); apply(nl);
      // the store also has a Shopify /en locale: switching moves to it, so checkout, the account pages
      // and e-mails follow the same language
      if (nl !== pageLoc) { var base = basePath(); location.href = (nl === 'en' ? '/en' + (base === '/' ? '' : base) : base) + location.search + location.hash; }
      return;
    }
    var cb = e.target.closest('[data-cur]');
    if (cb) { cur = cb.getAttribute('data-cur'); set(CUR, cur); renderMoney(); return; }
    var c = e.target.closest('[data-cookie-prefs]');
    if (c) {
      e.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); }
      else { location.href = '/policies/privacy-policy#cookies'; }
      return;
    }
    var m = e.target.closest('[data-menu]');
    if (m) {
      var p = document.getElementById('twMnav');
      var open = p.classList.toggle('open');
      m.setAttribute('aria-expanded', String(open));
    }
  });

  // ---------- spec filter (collection page): AND between groups, OR inside a group ----------
  var sf = document.getElementById('twSpecF');
  function specRun() {
    if (!sf) return;
    var want = {};
    sf.querySelectorAll('input.sf:checked').forEach(function (i) { (want[i.getAttribute('data-g')] = want[i.getAttribute('data-g')] || []).push(i.value); });
    var groups = Object.keys(want), shown = 0;
    document.querySelectorAll('.col-grid .card-w').forEach(function (c) {
      var have = (c.getAttribute('data-spec') || '').split('|');
      var ok = groups.every(function (g) { return want[g].some(function (v) { return have.indexOf(g + '=' + v) > -1; }); });
      c.hidden = !ok; if (ok) shown++;
    });
    sf.querySelectorAll('details.flt.spec').forEach(function (d) {
      var n = d.querySelectorAll('input.sf:checked').length, b = d.querySelector('.n');
      if (b) { b.textContent = n; b.hidden = !n; }
    });
    var cnt = document.getElementById('twCount'); if (cnt) cnt.textContent = groups.length ? shown : cnt.getAttribute('data-total');
    var none = document.getElementById('twSpecNone'); if (none) none.hidden = shown > 0;
    var rs = document.getElementById('twSpecReset'); if (rs) rs.hidden = !groups.length;
  }
  if (sf) {
    sf.addEventListener('change', function (e) { if (e.target.classList.contains('sf')) specRun(); });
    var rsb = document.getElementById('twSpecReset');
    if (rsb) rsb.addEventListener('click', function () { sf.querySelectorAll('input.sf:checked').forEach(function (i) { i.checked = false; }); specRun(); });
    // ?spec=Format=75%25&spec=Conexiune=Wireless preselects values (links from the homepage)
    try { new URLSearchParams(location.search).getAll('spec').forEach(function (q) { var i = q.indexOf('='); if (i < 1) return; var g = q.slice(0, i), v = q.slice(i + 1); sf.querySelectorAll('input.sf').forEach(function (x) { if (x.getAttribute('data-g') === g && x.value === v) x.checked = true; }); }); } catch (e) {}
    specRun();
  }

  // ---------- comparison: up to 3 products, kept in localStorage ----------
  var CMP = 'tw-cmp', MAX = 3, cmp = [];
  try { cmp = JSON.parse(get(CMP) || '[]') || []; } catch (e) { cmp = []; }
  var T = {
    ro: { cmp: 'Compară', add: 'Adaugă la comparație', added: 'În comparație', clear: 'Golește', max: 'Poți compara cel mult 3 produse.', title: 'Comparație produse', only: 'Doar diferențele', price: 'Preț', brand: 'Brand', remove: 'Elimină', lowest: 'cel mai mic', specs: 'Caracteristici', note: 'Rândurile evidențiate diferă între produse. Prețurile includ TVA.', from: 'de la ', close: 'Închide', slot: 'Loc liber' },
    en: { cmp: 'Compare', add: 'Add to comparison', added: 'In comparison', clear: 'Clear', max: 'You can compare up to 3 products.', title: 'Product comparison', only: 'Differences only', price: 'Price', brand: 'Brand', remove: 'Remove', lowest: 'lowest', specs: 'Key features', note: 'Highlighted rows differ between products. Prices include VAT.', from: 'from ', close: 'Close', slot: 'Empty slot' }
  };
  var SCALE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v15M8 19h8M5 7h14"/><path d="M5 7l-2.6 6h5.2zM19 7l-2.6 6h5.2z"/><path d="M2.4 13a2.6 2.6 0 0 0 5.2 0M16.4 13a2.6 2.6 0 0 0 5.2 0"/><circle cx="12" cy="4" r="1.1" fill="currentColor" stroke="none"/></svg>';
  function L() { return T[lang] || T.ro; }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function dict() { var d = document.getElementById('twDict'); if (!d) return {}; try { return JSON.parse(d.textContent) || {}; } catch (e) { return {}; } }
  function tr(v) { var d = dict(); return lang === 'en' && d[v] ? d[v] : v; }
  function saveCmp() { set(CMP, JSON.stringify(cmp)); }
  function inCmp(h) { return cmp.some(function (x) { return x.h === h; }); }
  var tray = null, dlg = null, msgT = null;
  function ensureUI() {
    if (tray) return;
    tray = document.createElement('div'); tray.className = 'cmp-tray'; tray.hidden = true; tray.setAttribute('role', 'region');
    document.body.appendChild(tray);
    dlg = document.createElement('div'); dlg.className = 'cmp-dlg'; dlg.hidden = true; dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true');
    document.body.appendChild(dlg);
    tray.addEventListener('click', function (e) {
      var r = e.target.closest('[data-rm]'); if (r) { removeCmp(r.getAttribute('data-rm')); return; }
      if (e.target.closest('.go')) { openDlg(); return; }
      if (e.target.closest('.clr')) { cmp = []; saveCmp(); syncCmp(); }
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('.x')) { closeDlg(); return; }
      var r = e.target.closest('[data-rm]'); if (r) { removeCmp(r.getAttribute('data-rm')); if (cmp.length) renderDlg(); else closeDlg(); }
    });
    dlg.addEventListener('change', function (e) { if (e.target.id === 'twOnlyDiff') dlg.classList.toggle('only-diff', e.target.checked); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dlg && !dlg.hidden) closeDlg(); });
  }
  function flash(t) {
    var m = tray.querySelector('.msg'); if (!m) { m = document.createElement('div'); m.className = 'msg'; tray.appendChild(m); }
    m.textContent = t; m.hidden = false; clearTimeout(msgT); msgT = setTimeout(function () { m.hidden = true; }, 2600);
  }
  function renderTray() {
    ensureUI();
    var l = L(), slots = '';
    for (var i = 0; i < MAX; i++) {
      var x = cmp[i];
      slots += x ? '<div class="cmp-slot full" title="' + esc(lang === 'en' ? x.te : x.t) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="">' : '') + '<button type="button" data-rm="' + esc(x.h) + '" aria-label="' + l.remove + '">×</button></div>'
        : '<div class="cmp-slot" aria-label="' + l.slot + '"><span class="em">+</span></div>';
    }
    tray.innerHTML = '<div class="lbl">' + SCALE + '<span>' + l.cmp + '</span></div><div class="cmp-slots">' + slots + '</div>' +
      '<button type="button" class="go"' + (cmp.length < 2 ? ' disabled' : '') + '>' + l.cmp + ' (' + cmp.length + ')</button><button type="button" class="clr">' + l.clear + '</button>';
    tray.setAttribute('aria-label', l.title);
    tray.hidden = !cmp.length;
  }
  function syncCmp() {
    document.querySelectorAll('[data-cmp]').forEach(function (b) {
      var d; try { d = JSON.parse(b.getAttribute('data-cmp')); } catch (e) { return; }
      var on = inCmp(d.h), l = L();
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? l.added : l.add); b.title = on ? l.added : l.add;
      var t = b.querySelector('.txt'); if (t) t.textContent = on ? l.added : l.add;
    });
    renderTray();
  }
  function removeCmp(h) { cmp = cmp.filter(function (x) { return x.h !== h; }); saveCmp(); syncCmp(); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cmp]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var d; try { d = JSON.parse(b.getAttribute('data-cmp')); } catch (err) { return; }
    if (inCmp(d.h)) { removeCmp(d.h); return; }
    if (cmp.length >= MAX) { renderTray(); flash(L().max); return; }
    cmp.push(d); saveCmp(); syncCmp();
  }, true);
  function money(x) { return '<span data-cents="' + x.c + '" data-ron="' + esc(x.p) + '">' + esc(x.p) + '</span>'; }
  function renderDlg() {
    var l = L(), en = lang === 'en', n = cmp.length;
    // rows: union of spec rows, keyed by group + label (Romanian keys)
    var groups = [], gi = {};
    cmp.forEach(function (x, k) {
      (x.s || []).forEach(function (g) {
        if (gi[g.g] == null) { gi[g.g] = groups.length; groups.push({ g: g.g, ge: g.ge, rows: [], ri: {} }); }
        var G = groups[gi[g.g]];
        (g.r || []).forEach(function (r) {
          if (G.ri[r[0]] == null) { G.ri[r[0]] = G.rows.length; G.rows.push({ l: r[0], le: r[1], v: [] }); }
          G.rows[G.ri[r[0]]].v[k] = en ? (r[3] || r[2]) : r[2];
        });
      });
    });
    // filter facets (Format, Conexiune …) as an extra group
    var fg = { g: l.specs, ge: l.specs, rows: [], ri: {} };
    cmp.forEach(function (x, k) {
      (x.f || []).forEach(function (f) {
        var p = f.split('='); if (p.length < 2) return;
        if (fg.ri[p[0]] == null) { fg.ri[p[0]] = fg.rows.length; fg.rows.push({ l: p[0], le: tr(p[0]), v: [] }); }
        var row = fg.rows[fg.ri[p[0]]]; row.v[k] = row.v[k] ? row.v[k] + ', ' + tr(p[1]) : tr(p[1]);
      });
    });
    if (fg.rows.length) groups.push(fg);
    var minC = Math.min.apply(null, cmp.map(function (x) { return x.c; }));
    var cols = '<colgroup><col style="width:170px">' + cmp.map(function () { return '<col>'; }).join('') + '</colgroup>';
    var head = '<thead><tr><th></th>' + cmp.map(function (x) {
      return '<td><a class="ph" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="">' : '') + '</a><div class="vn">' + esc(x.v) + '</div><a class="nm" href="' + esc(x.u) + '">' + esc(en ? x.te : x.t) + '</a><br><button type="button" class="rm" data-rm="' + esc(x.h) + '">' + l.remove + '</button></td>';
    }).join('') + '</tr></thead>';
    var prices = cmp.map(function (x) { return x.c; });
    var body = '<tbody><tr class="price ' + (prices.every(function (c) { return c === prices[0]; }) ? 'same' : 'diff') + '"><th>' + l.price + '</th>' + cmp.map(function (x) {
      return '<td>' + (x.pv ? l.from : '') + money(x) + (n > 1 && x.c === minC && prices.some(function (c) { return c !== minC; }) ? '<span class="best">' + l.lowest + '</span>' : '') + '</td>';
    }).join('') + '</tr>';
    groups.forEach(function (G) {
      body += '<tr class="g"><th colspan="' + (n + 1) + '">' + esc(en ? G.ge : G.g) + '</th></tr>';
      G.rows.forEach(function (r) {
        var vals = []; for (var k = 0; k < n; k++) vals.push(r.v[k]);
        var same = vals.every(function (v) { return v === vals[0]; });
        body += '<tr class="' + (same ? 'same' : 'diff') + '"><th>' + esc(en ? r.le : r.l) + '</th>' + vals.map(function (v) { return v ? '<td>' + esc(v) + '</td>' : '<td class="na">—</td>'; }).join('') + '</tr>';
      });
    });
    body += '</tbody>';
    var only = dlg.classList.contains('only-diff');
    dlg.innerHTML = '<div class="cmp-box"><div class="cmp-top"><h2>' + SCALE + esc(l.title) + '</h2><div class="tools"><label><input type="checkbox" id="twOnlyDiff"' + (only ? ' checked' : '') + '> ' + l.only + '</label><button type="button" class="x" aria-label="' + l.close + '">×</button></div></div>' +
      '<div class="cmp-scroll"><table class="cmp-t">' + cols + head + body + '</table></div><p class="cmp-note">' + l.note + '</p></div>';
    dlg.setAttribute('aria-label', l.title);
    renderMoney();
  }
  var lastFocus = null;
  function openDlg() { if (cmp.length < 2) return; lastFocus = document.activeElement; renderDlg(); dlg.hidden = false; document.body.classList.add('cmp-open'); var x = dlg.querySelector('.x'); if (x) x.focus(); }
  function closeDlg() { dlg.hidden = true; document.body.classList.remove('cmp-open'); if (lastFocus) lastFocus.focus(); }
  document.addEventListener('tw:lang', function () { if (document.body) { syncCmp(); if (dlg && !dlg.hidden) renderDlg(); } });

  // the URL decides (/en = English); the head script already moved visitors to their saved language
  apply(pageLoc);
  syncCmp();

  document.querySelectorAll('[data-wave]').forEach(function (w, n) {
    var s = '', seed = Number(w.getAttribute('data-wave')) || n + 1;
    for (var i = 0; i < 64; i++) {
      var h = 5 + Math.round(Math.abs(Math.sin(i * 0.9 * seed) * Math.cos(i * 0.23 + seed)) * 24);
      s += '<i style="height:' + h + 'px"></i>';
    }
    w.innerHTML = s;
  });
})();
